import { render, staticRenderFns } from "./_entity_type.vue?vue&type=template&id=2e4ff302&"
import script from "./_entity_type.vue?vue&type=script&lang=js&"
export * from "./_entity_type.vue?vue&type=script&lang=js&"
import style0 from "./_entity_type.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {StickyHeader: require('/usr/src/app/components/business-formation/sticky-header.vue').default,LnCustomButton: require('/usr/src/app/components/ln-custom-button.vue').default,BfCheckmarks: require('/usr/src/app/components/business-formation/bf-checkmarks.vue').default,FormationSpecialist: require('/usr/src/app/components/business-formation/formation-specialist.vue').default,BfReviews: require('/usr/src/app/components/business-formation/bf-reviews.vue').default,BfTrustpilotReviews: require('/usr/src/app/components/business-formation/bf-trustpilot-reviews.vue').default,BfSteps: require('/usr/src/app/components/business-formation/bf-steps.vue').default,EntityFeatures: require('/usr/src/app/components/business-formation/entity-features.vue').default,Platform: require('/usr/src/app/components/common-sections/platform.vue').default,BfGuide: require('/usr/src/app/components/business-formation/bf-guide.vue').default,BfRush: require('/usr/src/app/components/business-formation/bf-rush.vue').default,EntityComparison: require('/usr/src/app/components/common-sections/entity-comparison.vue').default,FooterCta: require('/usr/src/app/components/common-sections/footer-cta.vue').default})
